import React, { useEffect, useRef } from 'react';

import PropTypes from 'prop-types';

function useOutsideAlerter(ref, effect) {
  useEffect(() => {
    function handleClickOutside(event) {
      if (ref.current && !ref.current.contains(event.target)) {
        if (typeof effect === 'function') effect();
      }
    }

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [effect, ref]);
}

/**
 * Component that alerts if you click outside of it
 */
const OutsideAlerter = ({ children, callback }) => {
  const wrapperRef = useRef(null);
  useOutsideAlerter(wrapperRef, callback);

  return <div ref={wrapperRef}>{children}</div>;
};

OutsideAlerter.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node
  ]).isRequired,
  callback: PropTypes.func
};

export default OutsideAlerter;
